import React from "react";
import { PrimaryButton } from "./Buttons";

const AppShell = ({
  sidebarImage = "/sidebar_avatar.png",
  logoSrc = "/church_logo_no_bg.png",
  logoAlt = "Faith Assembly Logo",
  logoPosition = "top",
  showLogout = false,
  onLogout,
  logoutLabel = "Logout",
  topbarActions = null,
  mainClassName = "",
  contentClassName = "",
  adminWaveImage = "/wave-1.png",
  children,
}) => {
  const logoPositionClass =
    logoPosition === "bottom" ? "ui-shell__logo--bottom" : "ui-shell__logo--top";
  const hasTopbarContent = showLogout || Boolean(topbarActions);
  const topbarClassName = hasTopbarContent
    ? "ui-shell__topbar"
    : "ui-shell__topbar ui-shell__topbar--compact";

  const mainStyle = mainClassName.includes("ui-shell__main--admin")
    ? { "--ui-admin-wave-image": `url("${adminWaveImage}")` }
    : undefined;

  return (
    <div className="ui-shell">
      <aside
        className="ui-shell__sidebar"
        style={{ backgroundImage: `url(${sidebarImage})` }}
        aria-hidden="true"
      >
        <img src={logoSrc} alt={logoAlt} className={`ui-shell__logo ${logoPositionClass}`} />
      </aside>

      <main className={`ui-shell__main ${mainClassName}`.trim()} style={mainStyle}>
        <div className={topbarClassName}>
          {topbarActions ? (
            <div className="ui-shell__topbar-actions">{topbarActions}</div>
          ) : null}

          {showLogout ? (
            <PrimaryButton onClick={onLogout} className="ui-shell__logout-btn ui-top-action-btn" size="md">
              {logoutLabel}
            </PrimaryButton>
          ) : null}
        </div>

        <div className={`ui-shell__content ${contentClassName}`.trim()}>{children}</div>
      </main>
    </div>
  );
};

export default AppShell;
